import { useAppContext } from "../../../contexts/AppContext";

// Jumps the call modal's player to a given second and plays from there, handing
// over from the sidebar player the same way the modal's play button does.
const usePopupAudioSeek = () => {
  const {
    popupAudioRef,
    popupAudioUrl,
    popupCallId,
    setPopupAudioTime,
    setPopupIsAudioPlaying,
    sidebarAudioRef,
    sidebarAudioUrl,
    sidebarIsAudioPlaying,
    setSidebarAudioUrl,
    setSidebarCallId,
  } = useAppContext();

  return (seconds) => {
    const audio = popupAudioRef?.current;
    if (!audio || !Number.isFinite(seconds)) return;

    audio.currentTime = seconds;
    setPopupAudioTime(seconds);
    // play() rejects while the audio is still loading or has no source.
    audio.play()?.catch?.(() => {});
    setPopupIsAudioPlaying(true);

    if (sidebarAudioUrl !== popupAudioUrl) {
      setSidebarAudioUrl(popupAudioUrl);
      setSidebarCallId(popupCallId);
    }
    if (sidebarIsAudioPlaying && sidebarAudioRef?.current) {
      sidebarAudioRef.current.pause();
    }
  };
};

export default usePopupAudioSeek;
